export const enumTypeStudentProfile = {
    INFO_PERSO : 0,
    ETUDES : 1,
    COMPETENCES : 2,
    SITUATION_PRO : 3,
}